// extracted by mini-css-extract-plugin
export default {"logoBar":"LogoHeader_logoBar__QEot6","logo":"LogoHeader_logo__zTAE9"};